<template>
  <Teleport to="body">
    <Transition name="app-loading">
      <div v-if="visible" class="app-loading" role="status" aria-live="polite">
        <span class="app-loading-spinner" aria-hidden="true" />
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
const { visible } = useGlobalLoading()
</script>

<style scoped>
.app-loading {
  position: fixed;
  inset: 0;
  z-index: 400;
  display: grid;
  place-items: center;
  background: rgb(0 0 0 / 35%);
}

.app-loading-spinner {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid rgb(255 255 255 / 25%);
  border-top-color: var(--primary, #f0a824);
  animation: app-loading-spin 0.8s linear infinite;
}

@keyframes app-loading-spin {
  to {
    transform: rotate(360deg);
  }
}

.app-loading-enter-active,
.app-loading-leave-active {
  transition: opacity 0.2s ease;
}

.app-loading-enter-from,
.app-loading-leave-to {
  opacity: 0;
}
</style>
